import React, { useContext, useEffect, useMemo, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { COLUMNS } from './columns'
import { LoginContext } from '../../../reactcontext/ReactContext'
import axios from 'axios'
import swal from 'sweetalert'
import PassportTable from './PassportTable'
import logo from '../../../assets/logo.avif'

const PassportTableInit = ({ filterType = "6_month" }) => {

  const apiUrl = process.env.REACT_APP_API_URL
  const [passports, setpassports] = useState([])
  const [errorMessage, setErrorMessage] = useState('')
  const [loading, setLoading] = useState(true)
  const { loginInfo } = useContext(LoginContext)

  const printedBy = loginInfo?.userDetails
    ? `${loginInfo.userDetails.firstName} ${loginInfo.userDetails.lastName}`
    : 'Admin'

  function getReadableTimestamp() {
    const now = new Date()
    return `${now.getFullYear()}-${String(now.getMonth()+1).padStart(2,'0')}-${String(now.getDate()).padStart(2,'0')} ${String(now.getHours()).padStart(2,'0')}:${String(now.getMinutes()).padStart(2,'0')}:${String(now.getSeconds()).padStart(2,'0')}`
  }

  const handleExportPDF = (data) => {
    if (!data || data.length === 0) return
    const html2pdf = require('html2pdf.js')
    const tdStyle = 'padding:4px 6px;border:1px solid #e5e7eb;'
    const rows = data.map((r, i) => `
      <tr style="background:${i % 2 === 0 ? '#fff' : '#f9fafb'}">
        <td style="${tdStyle}">${r.passportNo || 'N/A'}</td>
        <td style="${tdStyle}">${r.Employee ? `${r.Employee.firstName} ${r.Employee.lastName}` : 'N/A'}</td>
        <td style="${tdStyle}">${r.Employee?.mobile || 'N/A'}</td>
        <td style="${tdStyle}">${r.Employee?.Agent?.name || 'N/A'}</td>
        <td style="${tdStyle}">${r.expiryDate || 'N/A'}</td>
        <td style="${tdStyle}">${r.daysUntilExpiry ?? 'N/A'}</td>
      </tr>`).join('')
    const el = document.createElement('div')
    el.style.cssText = 'padding:20px;font-family:Arial,sans-serif;font-size:11px;'
    el.innerHTML = `
      <div style="text-align:center;margin-bottom:14px;">
        <img src="${logo}" style="width:60px;display:block;margin:0 auto 6px auto;" crossorigin="anonymous"/>
        <div style="font-size:16px;font-weight:bold;margin:4px 0;">Rahman Group</div>
        <div style="font-size:13px;margin:2px 0;">Report Listing - Passport Expire</div>
      </div>
      <div style="display:flex;gap:30px;flex-wrap:wrap;margin-bottom:12px;">
        <span><em>Printed By:</em> <strong>${printedBy}</strong></span>
        <span><em>Printed On:</em> <strong>${getReadableTimestamp()}</strong></span>
        <span><em>Total Records:</em> <strong>${data.length}</strong></span>
        <span><em>Signature:</em> <strong>______________</strong></span>
      </div>
      <table style="width:100%;border-collapse:collapse;font-size:10px;">
        <thead><tr style="background:#e5e7eb;">
          <th style="padding:5px 6px;border:1px solid #d1d5db;text-align:left;">Passport No</th>
          <th style="padding:5px 6px;border:1px solid #d1d5db;text-align:left;">Full Name</th>
          <th style="padding:5px 6px;border:1px solid #d1d5db;text-align:left;">Mobile</th>
          <th style="padding:5px 6px;border:1px solid #d1d5db;text-align:left;">Agent</th>
          <th style="padding:5px 6px;border:1px solid #d1d5db;text-align:left;">Expiry Date</th>
          <th style="padding:5px 6px;border:1px solid #d1d5db;text-align:left;">Days Until Expiry</th>
        </tr></thead>
        <tbody>${rows}</tbody>
      </table>`
    html2pdf().set({
      margin: 10,
      image: { type: 'jpeg', quality: 0.98 },
      html2canvas: { scale: 2, useCORS: true },
      jsPDF: { unit: 'mm', format: 'a4', orientation: 'landscape' },
    }).from(el).outputPdf('blob').then(blob => {
      window.open(URL.createObjectURL(blob), '_blank')
    })
  }
  const navigate = useNavigate()
  const columns = useMemo(() => COLUMNS, [])

  useEffect(() => {
    !loginInfo.login && navigate("/")
  }, [loginInfo])

  // Fetch and filter passport data
  useEffect(() => {
    const loginToken = localStorage.getItem("loginToken");
    
    if (!loginToken) {
      console.log('No login token found');
      setLoading(false);
      return;
    }
    
    console.log(`Fetching passports with filterType: ${filterType}`);
    setLoading(true);
    
    if (filterType === "pass_expired") {
      // Fetch already expired passports
      axios.get(`${apiUrl}/employee/passportExpired`, {
        headers: {
          loginToken: loginToken
        }
      })
      .then(res => {
        console.log('Expired Passport Data:', res.data)
        if(res.data.error){
          setErrorMessage(res.data.error)
          setpassports([])
        } else {
          setpassports(res.data.passports || [])
        }
        setLoading(false)
      })
      .catch(err => {
        console.log('Error fetching expired passports:', err)
        swal({
          title: "Error",
          icon: "error",
          text: JSON.stringify(err.message)
        })
        setLoading(false)
      })
    } else {
      // Fetch passports expiring soon
      axios.get(`${apiUrl}/employee/passportExpire`, {
        headers: {
          loginToken: loginToken
        }
      })
      .then(res => {
        console.log('All Passport Data:', res.data)
        if(res.data.error){
          setErrorMessage(res.data.error)
          setpassports([])
        } else {
          // Filter based on days remaining
          const today = new Date();
          today.setHours(0, 0, 0, 0);
          
          console.log(`Today: ${today}, Filter: ${filterType}`);
          console.log(`Total passports from API: ${(res.data.passports || []).length}`);
          
          let filtered = (res.data.passports || []).filter(passport => {
            if (!passport.expiryDate) {
              console.log('Passport has no expiryDate:', passport);
              return false;
            }
            
            // Parse date string in format YYYY-MM-DD to avoid timezone issues
            const dateStr = passport.expiryDate.split('T')[0]; // Get just the date part
            const [year, month, day] = dateStr.split('-');
            const expiryDate = new Date(year, month - 1, day, 0, 0, 0, 0);
            
            const daysUntilExpiry = Math.floor((expiryDate - today) / (1000 * 60 * 60 * 24));
            
            console.log(`Passport ${passport.passportNumber}: expires ${expiryDate} (${dateStr}), days until: ${daysUntilExpiry}`);
            
            // Non-overlapping ranges
            if (filterType === "1_month") {
              return daysUntilExpiry >= 0 && daysUntilExpiry <= 30;
            } else if (filterType === "3_month") {
              return daysUntilExpiry > 30 && daysUntilExpiry <= 90;
            } else if (filterType === "6_month") {
              return daysUntilExpiry > 90 && daysUntilExpiry <= 180;
            }
            
            return false;
          });
          
          console.log(`Filtered ${filterType}: ${filtered.length} passports found`)
          setpassports(filtered)
        }
        setLoading(false)
      })
      .catch(err => {
        console.log('Error fetching passports:', err)
        swal({
          title: "Error",
          icon: "error",
          text: JSON.stringify(err.message)
        })
        setLoading(false)
      })
    }
  }, [filterType, apiUrl])

  return (
    <div className='w-full h-full overflow-auto'>
      <hr />
      {
        loading ? <p className='w-full h-full text-center text-lg py-5'>Fetching data... Please wait</p> :
          typeof passports === "undefined" && (
              <div className='w-full text-center text-lg py-5 gap-y-10 flex flex-col justify-center items-center'>
                <p>{"there are no any expiry passports"}</p>
              </div>              
            )
      }

      {
        typeof passports === "object" &&  
        <PassportTable
          columns={columns}
          data={passports}
          onExportPDF={handleExportPDF}
        />
      }
    </div>
  )
}

export default PassportTableInit
